define('models/shared/session',[
	'underscore',
	'backbone',
	'cookie',
	'models/shared/user/role_collection',
	'models/shared/user/roleaccess_collection',
	'models/shared/settings/settingvalue_collection',
	'models/shared/lookups/lookups',
	'models/shared/securityquestions/securityquestion_collection'
], function(_, Backbone, Cookie, Roles, RolesAccess, SettingValues, ApplicationControls, SecurityQuestions){
	var attempts = 0;

	var SessionModel = Backbone.Model.extend({

		defaults: {
			auth                  : false,
			secureAuth            : false,
			ISPZipCode            : undefined,
			RememberManchine      : false,
			MachineValidatedByUser: false
		},

		initialize: function(){
			var that = this;
			var showConverationView = false;
			var showAccountsView = false;
			this.handled = false;
			this.serverAttrs = ['lauth'];

			//this.cognito = new Cognito();

			$.ajaxPrefilter(function(options, originalOptions, xhr){
				
				if(typeof options.external === "undefined"){

					//var token = $.cookie("token");
					var token = getToken();
					var csrf = that.get("_csrf");
					var antiForgeryToken = that.get("aft");
					var antiForgeryCookieToken = that.get("aftc");

					if(csrf != null){
						xhr.setRequestHeader("X-CSRF-Token", csrf);
					} else if(token != null){
						xhr.setRequestHeader("Authorization", "Bearer " + token);
					}

					if(antiForgeryToken != null && antiForgeryCookieToken != null){
						switch (options.type) {
							case "POST":
							case "PUT":
							case "DELETE":
								xhr.setRequestHeader("__RequestVerificationToken", antiForgeryCookieToken + ":" + antiForgeryToken);
								break;
						}
					}

				}

			});

			$(document).ajaxError(function(e, xhr, options){
				var authenticated = that.get("auth");
				if(authenticated && !that.handled){
					that.handled = true;

					switch (xhr.status) {
						case 401:
							// Financial auth timed out
							that.needLogin();
							// if(that.handleLoginInSession()){
							//     that.needLogin();
							// }
							break;
						case 412:
							// CIP Required
							that.needCIP();
							break;
						case 426:
							// Upgrade Required (Older unsupported browser)
							that.showUpgradeBrowserView();
							break;
						case 460:
							// Social user only
							// Financial Registration Required
							that.financialRegistration();
							break;
						case 461:
							// Exceeded number of attempts
							break;
						case 503:
							that.viewOffline();
							break;
					};
					that.handled = false;

				} else if (!that.handled) {
					that.handled = true;

					switch (xhr.status) {
						case 401:
							// Financial auth timed out
							that.needLogin();
							// if(that.handleLoginInSession()){
							//     that.needLogin();
							// }
							break;
						case 412:
							// CIP Required
							that.needCIP();
							break;
						case 460:
							// Social user only
							// Financial Registration Required
							that.financialRegistration();
							break;
						case 461:
							// Exceeded number of attempts
							break;
					};

					that.handled = false;
				}
			});

		},

		urlRoot: function(){
			return pf.authURL + "/Token";
		},

		parse: function(data){
			data = data || {};
			
			//campaign info
			if(data.C){
				pf.AmountToInvitee = data.C.AINVE;
				pf.AmountToInviter = data.C.AINVR;
			}

			var response = {};

			if(data.AC){
				response.ApplicationControls = new ApplicationControls(data.AC);
			}

			if(data.U != null){

				response.UserGUID = data.U.UG;
				response.FirstName = data.U.FN;
				response.LastName = data.U.LN;
				response.EmailGUID = data.U.EG;
				response.eMail = data.U.E;
				response.EmailVerified = data.U.EV;
				response.Verified = data.U.V;
				response.Description = data.U.D;
				response.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.U.UG, pf.enums.imageTypeGUIDEnum.Thumbnail, data.U.PU);
				response.ITP = data.U.ITP;
				response.MachineValidatedByUser = data.U.MVU;
				response.RememberManchine = data.U.RM;
				response.Roles = new Roles(data.U.AR, { parse: true });
				response.RolesAccess = new RolesAccess(data.U.ARA, { parse: true });
				response.UserSettingAttributes = new SettingValues(data.U.USA, { parse: true });
				response.SecurityQuestions = new SecurityQuestions(data.U.SQ, { parse: true });
				response.CIPStatus = data.U.CIPS;
				response.CipStatusId = data.U.CIPSID;
				response.UserStatusId = data.U.USID;
				response.CardType = data.U.CT;
				response.ZipCodeLive = data.U.ZCL;
				response.ZipCode = data.U.Z;
				response.ISPZipCode = data.U.IZ;
				response.Eligibility = data.U.EL;

				response.LocalZipCode = null;
				response.localQuery = null;
				response.queryId = null;
				response.merchantSortPref = null;
				response.merchantCategoryPref = null;
				response.searchPref = null;
				response.currentLocationPosition = null;
				response.locationSearchPosition = null;
				response.locationSearchName = null;
				response.globalSearchPref = null;
				response.searchCityStateName = null;
				response.locationPreference = null;

				this.saveRoles(response);
				response.ApplicationControls = new ApplicationControls(data.AC);

			}

			return response;
		},

		save: function(attributes, options){
			attributes = attributes || this.toJSON();
			options = options || {};

			if(this.serverAttrs){
				attributes = _.pick(attributes, this.serverAttrs);
			}

			options.attributes = attributes;

			Backbone.Model.prototype.save.call(this, attributes, options);
		},

		saveRoles: function(data){

			pf.IsConsumerSocial = false;
			pf.IsConsumerFinancial = false;
			pf.IsZCardholder = false;
			pf.IsEmployee = false;
			pf.IsConsumerNpoManager = false;
			pf.IsCertifiedCauseUser = false;

			data.Roles.forEach(function(model){

				var m = model.toJSON();

				pf.IsEmployee = false;

				switch(m.RoleID){
					case pf.enums.roleEnum.ConsumerSocial:
						pf.IsConsumerSocial = true;
						break;
					case pf.enums.roleEnum.Employee:
						pf.IsEmployee = true;
						break;
					case pf.enums.roleEnum.ConsumerFinancial:
						pf.IsConsumerFinancial = true;
						break;
					case pf.enums.roleEnum.NonProfit:
						pf.IsConsumerNpoManager = true;
						break;
					case pf.enums.roleEnum.PFCertifiedCause:
						pf.IsCertifiedCauseUser = true;
						break;
					case pf.enums.roleEnum.ZCardHolder:
						pf.IsZCardholder = true;
						break;
					default:
						break;
				};

			});

		},

		getGlobalSearchPref: function(){
			if(localStorage.getItem('globalSearchPref')){
				return Number(localStorage.getItem('globalSearchPref'));
			} else {
				return this.attributes.globalSearchPref;
			}
		},

		setGlobalSearchPref: function(pref){
			localStorage.setItem('globalSearchPref', Number(pref))
			this.attributes.globalSearchPref = Number(pref);
		},

		getMerchantSortPref: function(){
			return this.attributes.merchantSortPref;
		},

		setMerchantSortPref: function(pref){
			this.attributes.merchantSortPref = pref;
		},

		getMerchantCategoryPref: function(){
			return this.attributes.merchantCategoryPref;
		},

		setMerchantCategoryPref: function(pref){
			this.attributes.merchantCategoryPref = pref;
		},

		setMerchantCityStateName: function(city){
			this.attributes.searchCityStateName = city;
		},

		getMerchantCityStateName: function(city){
			return this.attributes.searchCityStateName;
		},

		getSearchPref: function(){
			return this.attributes.searchPref;
		},

		setSearchPref: function(search){
			this.attributes.searchPref = search;
		},

		getLocalQuery: function(){
			return this.attributes.localQuery;
		},

		setLocalQuery: function(query){
			this.attributes.localQuery = query;
		},

		getQueryId: function(){
			return this.attributes.queryId;
		},

		setQueryId: function(id){
			this.attributes.queryId = id;
		},

		getOnlineLocalQuery: function(){
			return this.attributes.localOnlineQuery;
		},

		setOnlineLocalQuery: function(query){
			this.attributes.localOnlineQuery = query;
		},

		getOnlineQueryId: function(){
			return this.attributes.onlineQueryId;
		},

		setOnlineQueryId: function(id){
			this.attributes.onlineQueryId = id;
		},

		getCurrentPosition: function(){
			return this.attributes.currentLocationPosition;
		},

		setCurrentPosition: function(position){
			this.attributes.currentLocationPosition = position;
		},

		getLocationPreference: function(){
			return this.attributes.locationPreference;
		},

		setLocationPreference: function(preference){
			this.attributes.locationPreference = preference;
		},

		getLocationSearchPosition: function(position){
			return this.attributes.locationSearchPosition;
		},

		setLocationSearchPosition: function(position){
			this.attributes.locationSearchPosition = position;
		},

		getLocationSearchName: function(name){
			return this.attributes.locationSearchName;
		},

		setLocationSearchName: function(name){
			this.attributes.locationSearchName = name;
		},

		getLocalZipCode: function(){
			return this.attributes.LocalZipCode;
		},

		setLocalZipcode: function(zip){
			this.attributes.LocalZipCode = zip;
		},

		getISPZip: function(){
			var that = this;
			var zipCode;

			if(!this.attributes.ISPZipCode){

				$.ajax({
					async: false,
					type: 'GET',
					url: pf.lookupsURL + "/ISPInfo",
					contentType: "application/json",
					success: function(resp, model){
						zipCode = resp.ZipCode;
					},
					error: function(resp, model){
					}
				});

			} else {
				var zipCode = this.attributes.ISPZipCode;
			}

			return zipCode;
		},

		handleLoginInSession: function(){
			if(window.location.hash.indexOf('ecard') > 0){
				return false;
			}
			return true;
		},

		login: function(options, callback){
			var that = this;

			store.removeStoreItem();
			this.set({ id: null });

			var token = getToken(),
				csrf = that.get("_csrf");

			if((typeof token === "undefined" || token == null) && (typeof csrf === "undefined" || csrf == null)){

				this.getAuth(function(){
					that.loginUser(options, callback);
				});

			} else {
				this.loginUser(options, callback);
			}
		},

		loginUser: function(options, callback){
			var that = this,
				value = options.E + ',' + options.P + ',' + options.FP + ',' + options.RC,
				encrypted = encrypt(value);

			this.set({ id: null });

			this.save({ lauth: encrypted }, {

				success: function(model, resp){
				  that.loginUserSuccess(model, resp, options, callback)
				},

				error: function(model, resp){
					var displayError = true;

					switch(resp.status){
						case 303:
							displayError = false;
							that.loginUserSuccess(model, resp, options, callback);
							break;
						case 400:

							if(_.isFunction(callback)){
								callback(null);
							}
							
							break;
						case 401:
							that.logout();
							break;
						case 403:
						case 408:
							displayError = false;
							that.cleanup();
							that.getAuth(function(){
								that.loginUser(options, callback);
							});

							if(_.isFunction(callback)){
								callback(null);
							}
							
							break;
						case 503:
							that.viewOffline();
							break;
					};

					that.handled = false;

					if(displayError){

						var bodyText = pf.getContent('login.fail_body'),
							phone = formatPhone(pf.getContent('global.phone.member_services')),
							email = pf.getContent('global.email.member_services');
						
						bodyText = bodyText.replace( '{memberServicesPhone}', phone );
						bodyText = bodyText.replace( '{memberServicesEmail}', email );
						
						pfdialog.error({
							context: this,
							Title: pf.getContent('login.fail_title'),
							Body: bodyText
						});

					}

				}
			});
		},

		loginUserSuccess: function(model, resp, options, callback) {

			/**
			 * Move the success object logic to it's own 
			 * function so we can handle 303 POST.
			 */

			var that = this;

			attempts = 0;

			if(resp.T != null){
				that.set({ auth: false, _csrf: resp.T });
			}
			if(resp.F != null){
				that.set({ aft: resp.F });
			}
			if(resp.FC != null){
				that.set({ aftc: resp.FC });
			}
			if(!options.verifyonly){
				that.saveToken(resp);
			}

			// TODO: Find somewhere to add this, after the Bearer token is added to AJAX request
			// if(pf.controller){
			//     pf.controller.loadAccounts();
			// }

			that.handled = false;

			pf.bootstrap(function(){

				if(_.isFunction(callback)){
					callback(resp);
				}

			});

		},

		saveToken: function(resp){
			var date = new Date();

			this.attributes = _.extend(this.parse(resp), this.attributes);

			var minutes = resp.Expires;

			//if (minutes > 0) {
				//date.setTime(date.getTime() + (minutes * 60 * 1000));
				//$.cookie("token", resp.AccessToken, { path: '/', expires: date });
			//} else {
				//$.cookie("token", resp.AccessToken, { path: '/' });
			//}

			setToken(resp.AccessToken, minutes);

			if(resp.F != null){
				this.set({ aft: resp.F });
			}

			if(resp.FC != null){
				this.set({ aftc: resp.FC });
			}

			this.set({ auth: true, _csrf: null, secureAuth: true });
		},

		logout: function(){
			var that = this;
			var auth = this.get("auth");

			this.set({ id: that.get("UserGUID") });

			this.destroy({
				success: function(model, resp){
					//that.cognito.signout();

					model.clear();
					model.id = null;
					that.cleanup();
					store.removeStoreItem();

					if (pf.accounts) {
						pf.accounts = null;
					}

					if (pf.wellness_account) {
						pf.wellness_account = null;
						pf.controller.wellness_account_called = false;
					}

					// Reset features so that it is not user specific, only domain specific
					getFeatures(null, function(features){

						pf.features = features || [];

						if (!pf.getCurrentRoute()) {
							Backbone.history.loadUrl();
						} else {
							pf.navigate("", { trigger: true });
						}

					});

				},
				error: function(model, resp){}
			});
			
		},

		getAuth: function(callback){
			var that = this;

			this.fetch({
				success: function(model, resp){

					if(resp.T != null){
						that.set({ auth: false, _csrf: resp.T, aft: resp.F });
					}

					if(resp.A){

						that.set({ auth: true, _csrf: null, aft: resp.F });

						if(resp.SA){
							that.set({secureAuth: true});
						}

					} else {

						var token = getToken();

						if(!isEmpty(token)){
							removeToken();
						}

					}

					if(resp.F != null){
						that.set({ aft: resp.F });
					}

					if(resp.FC != null){
						that.set({ aftc: resp.FC });
					}

					pf.apikey = resp.I;
					pf.pKey = resp.K;
					pf.contentFileName = resp.CFN;
					pf.isValidBrowser = resp.IVB;

					if(callback){
						callback();
					}
				},
				error: function(model, resp){

					switch(resp.status){
						case 500:
							break;
						case 503:
							that.viewOffline();
							break;
					};

				}
			});
		},

		getAntiForgery: function(){
			var that = this;

			this.fetch({
				url: pf.helperURL + "/AntiForgeryToken",
				success: function(model, resp){
					if(resp != null){
						that.set({ aft: resp });
					}
				},
				error: function(model, resp){
					switch(resp.status){
						case 500:
							break;
					};
				}
			});
		},

		validate: function(attributes){

			if(!attributes.lauth){
				alert("Please provide your login credentials and try again.");
			}

		},

		viewLogin: function(goHome, callback){

			if(_.isFunction(pf.viewLogin)){

				pf.viewLogin(goHome, callback, null, { isNotPopup : true });

			}
			
		},

		showUpgradeBrowserView: function(){
			
			if(_.isFunction(pf.controller.showUpgradeBrowserView)){
				pf.controller.showUpgradeBrowserView();
			}
			
		},

		viewOffline: function(){
			window.location = "http://offline.payforward.com";
		},

		needLogin: function(){
			var that = this;

			this.cleanup(true);

			if($.fancybox){
				$.fancybox.close();
			}
			
			this.closeModal();

			this.viewLogin(false, function(){
				that.handled = false;
			});
		},

		financialRegistration: function(){
			var product = enums.cardTypes.VirtualCard;

			pf.controller.showMemberApplication(product, false);
		},

		needCIP: function(){
			var that = this;

			// this.cleanup(true);
			$.fancybox.close();
			this.closeModal();

			saveCipTriggerRoute(Backbone.history.getFragment());

			pf.navigate('register/financial/cip',{ trigger: true });
		},

		closeModal: function(){
			$('#pf-modal-modern').fadeOut(function(){
				$('#pf-modal-modern').remove();
			});
		},

		setRouteMetadata: function(data){
			var meta = new ApplicationControls(data, { parse: true });

			meta.forEach(function(model){
				switch(model.Key){
					case "CampaignCode":
						store.setStoreItem(enums.modelsEnum.campaign, { Data: model.Value });
					case "ReferralCode":
						store.setStoreItem(enums.modelsEnum.ReferralCode, { Data: model.Value });
				}
			});

		},

		//manageCognito: function(password, callback){
		//    callback = callback || {};

		//    let that = this,
		//        userGUID = this.get("UserGUID"),
		//        eMail = this.get("eMail"),
		//        firstName = this.get("FirstName"),
		//        lastName = this.get("LastName");

		//    if (!isEmpty(eMail) && !isEmpty(password)) {
		//        this.cognito.signin(eMail, password, function(err, result){
		//            if (err) {
		//                if (err.code === 'UserNotFoundException') {
		//                    that.cognito.registerUser(userGUID, firstName, lastName, eMail, null, eMail, password, function(err, user){
		//                        if (err) {
		//                            callback(err);
		//                        } else {
		//                            callback(null, user);
		//                        }
		//                    });
		//                } else {
		//                    callback(err);
		//                }
		//            } else {
		//                callback(null, result.idToken.jwtToken);
		//            }
		//        });
		//    }
		//},

		cleanup: function(dontHandle){

			removeToken();

			if(!dontHandle || dontHandle == undefined){
				this.handled = false;
			}

			this.ReferralCode = null;
			this.ReferralURL = null;
			this.ShortReferralURL = null;

			this.set({ auth: false, _csrf: null, aft: null, aftc: null, secureAuth: false });
		}
	});

	return SessionModel;
});

